module.exports = __webpack_public_path__ + "img/ter.dcba7cc9.png";